import { Navigate, useLocation } from 'react-router-dom'
import { buildLocalePath, getDefaultLanguageForLocale, DEFAULT_LOCALE, type Locale, type Language } from '@/lib/router'

function detectLocale(): Locale {
  // Year 1: US-only. When expanding: read navigator.language or a geo-IP cookie.
  return DEFAULT_LOCALE
}

function detectLanguage(locale: Locale): Language {
  return getDefaultLanguageForLocale(locale)
}

/**
 * Redirects bare "/" and any path without a locale prefix to the correct /:locale/:lang/ path.
 * Preserves the original pathname (minus any existing locale prefix), search, and hash.
 */
export function LocaleRedirect({ sourcePath }: { sourcePath?: string }) {
  const location = useLocation()
  const locale = detectLocale()
  const lang = detectLanguage(locale)
  const path = sourcePath ?? location.pathname
  const target = buildLocalePath(locale, lang, path)
  const full = `${target}${location.search}${location.hash}`
  return <Navigate to={full} replace />
}
